import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import UploadDocumentFormContainer from "./uploadDocumentFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useSharedDocumentUploadDialog(onActionSuccess?: () => void): DialogProps {
  return {
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AddDocument),
    titleIcon: IconDefinitionConstants.WDocument,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
        successMessage: TranslationKeys.Document.CreateSuccess,
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    children: <UploadDocumentFormContainer />,
    maxWidth: "sm",
    onSubmit: onActionSuccess,
  };
}

export default useSharedDocumentUploadDialog;
